import PouchDB from "pouchdb-browser";
import find from "pouchdb-find";

PouchDB.plugin(find);

// PouchDB.debug.enable("pouchdb:find");
